import React, { useState, useEffect } from "react";
import axios from "axios";
import authUser from '../../assets/js/auth'
import StripeCheckout from "react-stripe-checkout";
import CharryConverter from "../../assets/js/conversionCharry";
import FormBuilder from "../../assets/js/formBuilder";
import SendingTokensModal from "../SendingTokensModal";
import coinGecko from "../../assets/js/coinGecko";
import "./css/Packages.css";
import { Button, Modal } from "react-bootstrap";
import Utils from "../../utils/index";

require("dotenv").config();

const STRIPE_PUBLIC = process.env.REACT_APP_STRIPE_PUBLIC;
const ICO_CONTRACT_ADDRESS = process.env.REACT_APP_ICO_CONTRACT_ADDRESS;

const Packages = (props) => {

    const [showDialog, setShowDialog] = useState(false)
    const [tronWebState, setTronWebState] = useState({
        installed: false,
        loggedIn: false,
    })
    const [isLoading, setIsLoading] = useState(true)
    const [sendingTokens, setSendingTokens] = useState(false)
    const [trxData, setTRXData] = useState([])
    const [currency, setCurrency] = useState(props.currency)
    const [loggedIn, setLoggedIn] = useState(false)

    const setTronWeb = async () => {
        await new Promise((resolve) => {
            const tronWebStateInitial = {
                installed: !!window.tronWeb,
                loggedIn: window.tronWeb && window.tronWeb.ready,
            };

            if (tronWebState.installed) {
                setTronWebState(tronWebStateInitial);
                return resolve();
            }

            let tries = 0;

            const timer = setInterval(() => {
                if (tries >= 10) {
                    setTronWebState({
                        installed: false,
                        loggedIn: false,
                    });

                    clearInterval(timer);
                    return resolve();
                }

                tronWebState.installed = !!window.tronWeb;
                tronWebState.loggedIn = window.tronWeb && window.tronWeb.ready;

                if (!tronWebState.installed) return tries++;

                setTronWebState(tronWebStateInitial);

                resolve();
            }, 100);
        }).then(() => {
            return true
        }).catch((err) => {
            console.log(err)
        })

    }


    useEffect(() => {
        setIsLoading(true);
        setTronWeb()
        const fetchcoinDetails = async () => {

            let trxPriceData

            setIsLoading(true)
            trxPriceData = await coinGecko.get("/coins/markets", {
                params: {
                    vs_currency: currency,
                    ids: "tron"
                }
            })

            setTRXData(trxPriceData.data[0])


        }

        fetchcoinDetails()
        checkUpdate()
        authUser.isAuthenticated()
        if (authUser.authenticated === "false") {
            setLoggedIn(false)
        } else {
            setLoggedIn(true)
        }
        setIsLoading(false)

    }, [currency])

    const checkUpdate = () => {
        setInterval(() => {
            if (window.localStorage.getItem('CurrentCurrency')) {
                setCurrency(window.localStorage.getItem('CurrentCurrency'));
            }
        }, 1000)
    }

    const handleClose = () => {
        setShowDialog(false)
    }

    const buyTokensINR = async (amount) => {
        const inrAmt = (amount * trxData.current_price).toFixed(2)
        await axios.post(`${process.env.REACT_APP_BACKEND_API}/paymentINR`, {
            phone: `${window.localStorage.getItem('MobileNumber')}`,
            amount: `${inrAmt}`
        }).then(async (res) => {
            let information = {
                action: "https://securegw-stage.paytm.in/order/process",
                params: res.data
            }
            FormBuilder.post(information)
        }).catch((error) => {
            console.log("Error")
        })

    }


    const buyTokensTRX = async (amount) => {
        let tronWebStateCurrent = tronWebState;
        if (!tronWebStateCurrent.installed || !tronWebStateCurrent.loggedIn) {
            setShowDialog(true)
        } else if (
            tronWebStateCurrent.installed &&
            tronWebStateCurrent.loggedIn
        ) {
            setSendingTokens(true)
            let numTokens = CharryConverter.fromCharry(amount);
            let userWalletAddress = window.tronWeb.defaultAddress.base58;
            await Utils.setTronWeb(window.tronWeb, ICO_CONTRACT_ADDRESS);

            await Utils.contract
                .invest(userWalletAddress, numTokens)
                .send({
                    shouldPollResponse: true,
                    callValue: Utils.tronWeb.toSun(amount),
                })
                .then((hash) => {
                    console.log(hash);
                    setSendingTokens(false)
                })
                .catch((err) => {
                    console.log(err);
                    setSendingTokens(false)
                });
        }
    }

    const buyTokensTRXLoggedIn = async (amount) => {
        let tronWebStateCurrent = tronWebState;
        if (!tronWebStateCurrent.installed || !tronWebStateCurrent.loggedIn) {
            setShowDialog(true)
        } else if (
            tronWebStateCurrent.installed &&
            tronWebStateCurrent.loggedIn
        ) {
            setSendingTokens(true)
            let numTokens = CharryConverter.fromCharry(amount);
            let userWalletAddress = window.localStorage.getItem('account');
            await Utils.setTronWeb(window.tronWeb, ICO_CONTRACT_ADDRESS);

            await Utils.contract
                .invest(userWalletAddress, numTokens)
                .send({
                    shouldPollResponse: true,
                    callValue: Utils.tronWeb.toSun(amount),
                })
                .then((hash) => {
                    console.log(hash);
                    setSendingTokens(false)
                })
                .catch((err) => {
                    console.log(err);
                    setSendingTokens(false)
                });
        }
    }

    const makePayment = async (token, amount) => {
        axios.defaults.withCredentials = true;
        await axios.post(`${process.env.REACT_APP_BACKEND_API}/paymentUSD`, {
            usdAmt: amount,
            token: token
        }).then((res) => {
            console.log(res.data.code)
            console.log(res.data.status)
            window.location.href = `/${res.data.status}/${res.data.code}`
        }).catch((error) => {
            console.log("Error")
        })
    }



    const renderBtn = (amount) => {
        if (window.localStorage.getItem('CurrentCurrency') === 'inr' || window.localStorage.getItem('CurrentCurrency') === null) {
            return (
                <button
                    className="me-btn"
                    onClick={() => {
                        if (loggedIn) {
                            buyTokensINR(amount)
                        } else {
                            props.onOpenModalLogin()
                        }
                    }}
                >Buy with INR</button>
            )
        } else {
            const amtUSD = (amount * trxData.current_price).toFixed(2)
            if (loggedIn) {
                return (

                    <StripeCheckout stripeKey={STRIPE_PUBLIC} token={(token) => { makePayment(token, amtUSD) }} name="Buy CHY" billingAddress shippingAddress>
                        <button type="button" className="me-btn">Buy with USD</button>
                    </StripeCheckout>
                )
            } else {
                return (
                    <button
                        className="me-btn"
                        onClick={() => {
                            props.onOpenModalLogin()
                        }}
                    >Buy with USD</button>
                )
            }

        }
    }

    const renderPackages = () => {
        if (isLoading) {
            return (
                <div>Loading...</div>
            )
        } else {
            return (
                <div className="packages-wrapper">
                    <div className="me-plans me-padder-top-less me-padder-bottom">
                        <div className="container">
                            <div className="me-heading2">
                                <h4>Investing lets you earn regular rewards on your cryptocurrency holdings</h4>
                                <h1>Earn More</h1>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="me-plans-box">
                                        <div className="me-plan-header">
                                            <h1 className="me-plan-title">Standard</h1>
                                            <div className="me-plan-price">100 CHY</div>
                                        </div>
                                        <div className="me-plan-footer">
                                            <button
                                                className="me-btn"
                                                value="TRX"
                                                onClick={() => {
                                                    if (loggedIn) {
                                                        buyTokensTRXLoggedIn("100")
                                                    } else {
                                                        buyTokensTRX("100")
                                                    }
                                                }
                                                }
                                            >
                                                Buy with TRX
                                            </button>
                                            {renderBtn('100')}
                                        </div>
                                        <div className="me-plan-shape"></div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="me-plans-box">
                                        <div className="me-plan-header">
                                            <h1 className="me-plan-title">Basic</h1>
                                            <div className="me-plan-price">500 CHY</div>
                                        </div>
                                        <div className="me-plan-footer">
                                            <button
                                                className="me-btn"
                                                value="TRX"
                                                onClick={() => {
                                                    if (loggedIn) {
                                                        buyTokensTRXLoggedIn("500")
                                                    } else {
                                                        buyTokensTRX("500")
                                                    }

                                                }}
                                            >
                                                Buy with TRX
                                            </button>
                                            {renderBtn('500')}
                                        </div>
                                        <div className="me-plan-shape"></div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="me-plans-box">
                                        <div className="me-plan-header">
                                            <h1 className="me-plan-title">Advanced</h1>
                                            <div className="me-plan-price">1000 CHY</div>
                                        </div>
                                        <div className="me-plan-footer">
                                            <button
                                                className="me-btn"
                                                value="TRX"
                                                onClick={() => {
                                                    if (loggedIn) {
                                                        buyTokensTRXLoggedIn("1000")
                                                    } else {
                                                        buyTokensTRX("1000")
                                                    }
                                                }}
                                            >
                                                Buy with TRX
                                            </button>
                                            {renderBtn('1000')}
                                        </div>
                                        <div className="me-plan-shape"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )

        }
    }

    return (
        <>
            {renderPackages()}
            <Modal show={showDialog} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {tronWebState.installed ? (
                            tronWebState.loggedIn ? (
                                <></>
                            ) : (
                                <div>Login to TronLink Wallet</div>
                            )
                        ) : (
                            <div>Install TronLink Extension</div>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {tronWebState.installed ? (
                        tronWebState.loggedIn ? (
                            <></>
                        ) : (
                            <div>
                                Login to TronLink Wallet by click on Extension and entering
                                password
                            </div>
                        )
                    ) : (
                        <div>Download TronLink Wallet Extension from Chrome Webstore</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <SendingTokensModal
                sendingTokens={sendingTokens}
            />
        </>
    );
}

export default Packages;